import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_BASE, UPLOADS_BASE } from '../apiConfig';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/about.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';

const News = () => {
	const underlineRef = useRef(null);
	const [posts, setPosts] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [search, setSearch] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		AOS.init({ duration: 1000, once: true });
		
		// Fetch news posts from API
		axios
			.get(`${API_BASE}/blog`)
			.then((res) => {
				// Filter to show only news posts
				const newsPosts = (res.data || []).filter(post => post.post_type === 'news');
				setPosts(newsPosts);
				setLoading(false);
			})
			.catch((err) => {
				console.error('Error fetching news:', err.message);
				setError('Failed to load news');
				setLoading(false);
			});
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (underlineRef.current) {
				underlineRef.current.classList.add('animate');
			}
		}, 50);
		return () => clearTimeout(timer);
	}, []);

	return (
		<>
			<div className="container-fluid about-bg d-flex align-items-end" style={{ minHeight: '70vh', padding: 0, top: '-122px' }}>
				<div className="container about-content py-5">
					<div className="row">
						<div className="col-lg-8 col-md-10 col-12">
							<h1 className="about-title display-5 fw-bold">News</h1>
							<div className="about-underline mt-2" ref={underlineRef}></div>
						</div>
					</div>
				</div>
			</div>

			<section className="py-5 bg-white">
				<div className="container">
					<div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-4 gap-2">
						<h2 className="title mb-0" data-aos="fade-down" style={{ color: '#1565c0', fontWeight: 700 }}>Latest News</h2>
						<div className="ms-md-auto" style={{maxWidth: 360, width: '100%'}}>
							<input
								type="search"
								className="form-control"
								placeholder="Search news..."
								value={search}
								onChange={e => setSearch(e.target.value)}
							/>
						</div>
					</div>
					
					{loading && (
						<div className="text-center text-muted py-5">Loading news...</div>
					)}
					
					{!loading && error && (
						<div className="alert alert-danger">{error}</div>
					)}
					
					{!loading && !error && posts.length === 0 && (
						<div className="text-center text-muted py-5">No news articles yet.</div>
					)}
					
					<div className="row">
						{posts
							.filter(post => search ? (post.title || '').toLowerCase().includes(search.toLowerCase()) : true)
							.map((post, idx) => (
							<div key={post.id} className="col-md-6 col-lg-4 mb-4" data-aos="zoom-in" data-aos-delay={idx * 120}>
								<div className="card blog-card h-100 shadow-sm rounded-4 border-0" style={{transition:'transform .2s ease'}}>
									{post.image && (
										<img
											src={`${UPLOADS_BASE}/${post.image}`}
											alt="News"
											className="blog-card-img rounded-top-4"
											style={{ objectFit: 'cover', height: '220px', width: '100%' }}
										/>
									)}
									<div className="card-body d-flex flex-column">
										<div className="mb-2">
											<span className="badge bg-success">News Article</span>
										</div>
										<h5 className="blog-card-title mb-2" style={{ fontWeight: 700 }}>{post.title}</h5>
										<div className="mb-2 text-muted" style={{ fontSize: '0.9em' }}>
											<span>By: {post.author || 'Unknown'}</span>
											<span className="mx-2">|</span>
											<span>{post.created_at ? new Date(post.created_at).toLocaleDateString() : ''}</span>
										</div>
										<p className="text-muted small mb-3" style={{minHeight: '48px'}}>
											{(post.meta_description || '').slice(0, 110)}{(post.meta_description || '').length > 110 ? '…' : ''}
										</p>
										<button
											className="btn btn-success mt-auto"
											style={{ borderRadius: '20px', fontWeight: 600 }}
											onClick={() => navigate(`/news/${post.slug}`)}
										>
											Read More
										</button>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>
		</>
	);
};

export default News;
